// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CopyOutlinedSvg from "@ant-design/icons-svg/lib/asn/CopyOutlined";
import AntdIcon from "../components/AntdIcon";
const CopyOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CopyOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CopyOutlined.displayName = "CopyOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CopyOutlined);
